/*
 * @Author: Src
 * @Date: 2025-07-15 09:56:56
 * @LastEditTime: 2026-03-05 16:08:11
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/carRouter/carBrandRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import brandIndex from '@/views/carModule/brand/index.vue';
import { AuthEnum } from '@/services/permission.service';

const carShopRoutes: RouteConfig = {
  path: '/car',
  component: Main,
  redirect: {
    name: 'carbrand.index',
  },
  meta: {
    title: '车辆列表',
  },
  children: [
    {
      name: 'carbrand.index',
      path: '/car/brand',
      component: brandIndex,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车品牌列表],
      },
      meta: {
        title: '车辆列表',
      },
    },
  ],
};

export default carShopRoutes;
